<!--
 * @Description:
 * @Autor: wk
 * @Date: 2019-09-12 15:33:40
 * @LastEditors: lkz
 * @LastEditTime: 2021-05-25 17:48:39
 -->
<template>
  <div class="create-work-order-view" v-loading="loading">
    <header class="view-header" v-if="showHeader">
      <span>新建服务小记</span>
      <span class="header-btn" @click="$emit('close')">暂时隐藏</span>
    </header>
    <create-group
      ref="createGroupRef"
      @create="handleCreateWorkOder"
      :formItemList="formItemList">
      <el-form-item
        class="clues-item"
        required
        label="线索："
        >
        <el-select class="clues-select" v-model="form.woCluesType" @change="woCluesChange">
          <el-option
            v-for="(item, idx) in woCluesTypeArr"
            :key="idx"
            :label="item.value"
            :value="item.id"
          ></el-option>
        </el-select>
        <!-- <el-input class="clues-input" placeholder="请输入线索" v-model.trim="form.woCluesCode" @change="getshopArrByClues"></el-input> -->
        <el-input class="clues-input" placeholder="请输入线索" v-model.trim="form.woCluesCode" @change="selectOperation"></el-input>
        <el-select popper-class="shop-select" v-if="showCode" v-model="ownerCode" @change="getshopArrByClues">
          <el-option
            v-for="(item, idx) in ownerCodeList"
            :key="idx + 'own'"
            :label="item.ownerName"
            :value="item.ownerCode">
            {{item.ownerName}}
          </el-option>
        </el-select>

        <el-select popper-class="shop-select" v-if="form.woCluesType === 10 || form.woCluesType === 12" v-model="form.clewCode">
          <el-option
            v-for="(item, idx) in shopArr"
            :key="idx"
            :label="item.itemName"
            :value="item.clewCode">
            <div class="shop-item">
              <!-- <img class="shop-img" :src="item.itemImgSmall" > -->
              <div class="shop-info">
                <p class="shop-name">{{item.itemName}}</p>
                <span class="shop-type">SKU编码： {{item.itemSku}}</span>
                <span class="shop-type">规格： {{item.itemModel}}</span>
                <span class="shop-price">&yen;{{item.itemPrice}}x{{item.count}}</span>
              </div>
            </div>
          </el-option>
        </el-select>

        <el-select popper-class="shop-select" v-if="form.woCluesType === 11 && $route.query.loginOrigin === 'sso'" v-model="form.clewCode">
          <el-option
            v-for="(item, idx) in wuliuArr"
            :key="idx"
            :label="form.woCluesType === 11 && $route.query.loginOrigin === 'sso' ? item.omsOrderId : item.supplierName"
            :value="item.omsOrderId">
            <div class="shop-item">
              <!-- <img class="shop-img" :src="item.itemImgSmall" > -->
              <div class="shop-info">
                <p class="shop-name">{{item.omsOrderId}}</p>
                <span class="shop-type">仓库：{{item.warehouseName}}</span>
                <span class="shop-type">供应商：{{item.supplierName}}</span>
              </div>
            </div>
          </el-option>
        </el-select>

      </el-form-item>
      <el-form-item
        required
        label="工单原因：">
        <label class="has-icon"></label>
        <el-cascader
          ref="cascaderRef"
          :options="woReasionOpt"
          :props="woReasionProps"
          v-model="woReasionCode"
          @change="handleReasionChange"
          popper-class="cascader-bar">
        </el-cascader>
      </el-form-item>
    </create-group>
  </div>
</template>

<script>
import createGroup from '../components/CreateGroup'
import * as http from './allWorkOrder.service'
import { getLevelCount3Issues } from './allWorkOrder.service'

export default {
  name: 'createWorkOrder',
  components: {
    createGroup
  },
  props: {
    displayChannel: {
      type: String,
      default: '4'
    },
    conditionVal: {
      type: String,
      default: '通用渠道'
    },
    showHeader: {
      type: Boolean,
      default: false
    },
    sumbit: {
      type: Function
    }
  },
  data() {
    return {
      regionId: Number(this.$route.query.regionId || 1), // 业务域Id
      woCluesTypeArr: [],
      shopArr: [],
      form: {
        woCluesType: Number(this.$route.query.regionId) === 8 ? 13 : '', // 外系统跳转的自动选中商品ID
        woCluesCode: this.$route.query.woCluesCode || '', // 外系统跳转的自动填充
        clewCode: '',
        woReasion: ''
      },
      woReasionCode: [],
      woReasionProps: {
        value: 'serviceIssueId',
        label: 'title'
      },
      woReasionOpt: [],
      /**
       * formItemList 需要展示的过滤表单
       * fieldName 表单名称
       * value 对应的后台字段
       * wordType 表单类型 1数字型,2日期型,3枚举型,4文本型,5单选框,6复选框,7下拉框多选8下拉框级联单选
       * fieldOptionForms 选项 结构为name->label, id->value
       */
      formItemList: [],
      templateId: '', // 模板ID,根据原因查询模板时获取
      woType: '', // 工单类型,根据原因查询模板时获取
      showCode: false,
      ownerCodeList: [],
      ownerCode: '',
      wuliuArr: [],
      loading: false,
      queryIssueListTimmer: null,
      getClewChangeIssueListTimmer: null
    }
  },
  // watch: {
  //   'form.woCluesType'() {
  //     this.form.woCluesCode = ''
  //     this.form.clewCode = ''
  //     this.shopArr = []
  //     this.wuliuArr = []
  //   }
  // },
  mounted() {
    this.queryCluesTypeByRegionId()
    // this.queryIssueList() // !!！ 不知为何这里用旧的下面用新的，注释掉试试
    this.getClewChangeIssueList()
  },
  methods: {
    // 查询业务域下线索配置
    queryCluesTypeByRegionId() {
      const param = {
        workRegionId: this.regionId
      }
      http.queryCluesTypeByRegionId(param).subscribe((res) => {
        res = res.response.data
        if (res.errorCode === 0) {
          this.woCluesTypeArr = res.data || []
        }
      })
    },

    getClewChangeIssueList() {
      if (this.getClewChangeIssueListTimmer) {
        clearTimeout(this.getClewChangeIssueListTimmer)
      }
      this.getClewChangeIssueListTimmer = setTimeout(() => {
        const param = {
          clueType: this.form.woCluesType,
          displayChannel: this.regionId === 3 ? Number(this.$route.query.displayChannel || 4) : this.displayChannel,
          workRegionId: this.regionId
        }
        console.log(this.form, 'this.form')
        http.getLevelCount3Issues(param).subscribe(
          (res) => {
            if (res.response.data.data) {
              const { data } = res.response.data
              // 过滤空的children
              const arr = this.filterList(data)
              this.woReasionOpt = [].concat(arr)
            } else {
              this.woReasionOpt = []
            }
          }
        )
      }, 300)
    },
    // 获取工单问题树形结构
    queryIssueList() {
      if (this.queryIssueListTimmer) {
        clearTimeout(this.queryIssueListTimmer)
      }
      this.queryIssueListTimmer = setTimeout(() => {
        const { woCluesType } = this.form
        const param = {
          displayChannel: this.regionId === 3 ? Number(this.$route.query.displayChannel || 4) : this.displayChannel,
          workRegionId: this.regionId,
          clueType: woCluesType
        }
        http.serviceIssueList(param).subscribe(
          (res) => {
            if (res.response.data.data) {
              const { data } = res.response.data
              // 过滤空的children
              const arr = this.filterList(data)
              this.woReasionOpt = [].concat(arr)
            } else {
              this.woReasionOpt = []
            }
          }
        )
      }, 500)
    },
    filterList(list) {
      const arr = []
      const { length } = list
      for (let i = 0; i < length; i += 1) {
        if (Array.isArray(list[i].children)) {
          if (!list[i].children[0]) {
            delete list[i].children
          } else {
            list[i].children = this.filterList(list[i].children)
          }
        }
        arr.push(list[i])
      }
      return arr
    },
    // 切换线索
    woCluesChange() {
      this.form.woCluesCode = ''
      this.form.clewCode = ''
      this.shopArr = []
      this.wuliuArr = []
      if (this.form.woCluesType !== 12) this.showCode = false
      this.$nextTick(() => {
        this.woReasionCode = []
        // this.queryIssueList() 
        this.getClewChangeIssueList()
        // 重置创建表单
        // this.initFormData()
      })
    },
    // 选中工单原因
    handleReasionChange(val) {
      if (val) {
        const [{ data }] = this.$refs.cascaderRef.getCheckedNodes(true)
        this.form.woCluesType = data.clueType
        this.form.woReasonId = val.slice(-1).join()
        // 查询工单模板
        this.queryTempleteInfo()
      }
    },
    // 查询模板信息
    queryTempleteInfo() {
      let param = [
        {
          conditionCode: 1,
          conditionVal: this.regionId === 3 ? '仓储物流工作台' : this.conditionVal
        }, {
          conditionCode: 2,
          conditionVal: this.form.woReasonId.toString()
        }
      ]
      let isNewApi = false
      const arr = param
      if (this.form.woCluesType === 11 && this.regionId === 3 && this.$route.query.loginOrigin === 'sso') {
        param = {
          conditionsJson: JSON.stringify(arr),
          workRegionId: 3
        }
        isNewApi = true
      }
      // 重置创建表单
      // this.initFormData()
      http.queryTempleteInfo(param, { type: isNewApi ? 'formData' : '', isNewApi: isNewApi }).subscribe(
        (res) => {
          res = res.response.data
          if (res.errorCode === 0) {
            const list = (res.data && res.data.settings) || []
            this.templateId = (res.data && res.data.woTemplate && res.data.woTemplate.templateId) || ''
            this.woType = (res.data && res.data.woTemplate && res.data.woTemplate.orderType) || ''
            const formItemList = []
            list.forEach((item) => {
              if (item.value === 'woClew') return
              if (item.value === 'woReasion') return
              formItemList.push(item)
            })
            this.formItemList = formItemList
          }
        },
        () => {
          this.formItemList = []
        }
      )
    },
    // 单号查商品列表
    getshopArrByClues() {
      const { woCluesType, woCluesCode } = this.form
      if (woCluesType === 10 || woCluesType === 12) {
        const param = {
          clewType: woCluesType,
          srcOrder: woCluesCode,
          workRegionId: this.regionId
        }
        if (this.showCode) param.roleCode = this.ownerCode
        http.queryOrderProducts(param, { filterResponse: res => res }).subscribe((res) => {
          res = res.data
          if (res.errorCode === 0) {
            this.shopArr = res.data || []
          } else {
            this.shopArr = []
          }
        }, () => {
          this.shopArr = []
          this.form.clewCode = ''
        })
      }
    },
    // 创建工单事件
    handleCreateWorkOder(data, { formItemList, form }) {
      const param = {
        ...this.form, 
        ...data
      }

      if (param.clewCode) {
        if (param.woCluesType === 11 && this.$route.query.loginOrigin === 'sso') { // 不要问我这是什么逻辑，我也不懂
          const yso = param.clewCode
          // const code = param.woCluesCode
          // param.woCluesCode = code
          param.woCluesProperty = JSON.stringify({ yso: yso })
        } else {
          const property = param.woCluesType === 10 ? { so: param.woCluesCode } : { yso: param.woCluesCode }
          param.woCluesProperty = JSON.stringify(property)
          param.woCluesCode = param.clewCode
        }
      }
      if (param.files) {
        param.filesName = param.files.slice(param.files.indexOf('=') + 1)
        param.filesUrl = param.files.slice(0, param.files.indexOf('?'))
      }
      param.workRegion = this.regionId
      param.templateId = this.templateId
      param.woType = this.woType
      param.woDisplayChannel = '4'
      delete param.woReasion
      delete param.files
      delete param.checkExitSoOrder

      // 如果线索类型是手机号，校验正则表达式
      if (param.woCluesType === 15) {
        // 手机正则
        const phoneRegx = /^1[3-9]\d{9}$/
        if (!param.woCluesCode || !phoneRegx.test(param.woCluesCode)) {
          this.$message.error('创建失败: 请输入正确的手机号')
          return
        }
      }
      if (!param.templateId || !param.woType) {
        this.$message.error('创建失败：无法获取模板')
      } else if (!param.woCluesCode) {
        console.log('-----woCluesCode is null------')
        this.$message.error('请完善工单必填信息')
      } else if (param.woCluesType === 10 && !this.form.clewCode && this.shopArr.length > 0) {
        console.log('-----woCluesCode is null------')
        this.$message.error('请选择订单商品后再提交')
      } else if (param.woCluesType === 11 && !this.form.clewCode && this.wuliuArr.length > 0) {
        console.log('-----woCluesCode is null------')
        this.$message.error('请下拉选择物流后再提交')
      } else if (param.woCluesType === 10 && !this.form.clewCode && this.shopArr.length === 0) {
        this.$confirm('订单未生成so单，工单无法流转到仓库或商家，确认提交工单吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.startCreateWorkOrder(param, { formItemList, form })
        }).catch(() => {
        })
      } else {
        if (param.woPictures) param.woPictures = param.woPictures.join(',')
        if (param.woVideo) param.woVideo = param.woVideo
        // 添加 - 订单商品线索记录更新 2022.01.12
        param.checkExitSoOrder = true
        this.startCreateWorkOrder(param, { formItemList, form })
      }
    },
    // 开始创建工单
    startCreateWorkOrder(param, { formItemList, form }) {
      if (typeof this.sumbit === 'function') { // 回显使用
        param.woReasionCode = this.woReasionCode 
        param.ownerCode = this.ownerCode
        this.sumbit(param, { formItemList, form })
        return
      }
      this.loading = true
      delete param.clewCode
      http.createWorkOrder(param).subscribe(
        (res) => {
          this.loading = false
          res = res.response.data
          if (res.errorCode === 0) {
            window.parent.postMessage({ msg: 'vocCreateWork' }, '*') // VOC项目嵌入创建工单，创建成功通知voc关闭弹框
            this.$message.success('工单创建成功')
            this.$emit('reload')
            if (this.$listeners.refind) {
              this.$emit('refind')
            }
            this.$emit('close')
          } else {
            this.$message.error('工单创建失败')
          }
        },
        (res) => {
          this.loading = false
          // errorcode 不为0就直接进入error方法。详情查看responseFilters.js文件，并且重新组装了数据
          if (res.errorCode === 20000) {
            this.$confirm(res.responseText, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              // 确认后重新发起请求
              delete param.checkExitSoOrder
              this.startCreateWorkOrder(param)
            }).catch(() => {
            })
          } else {
            this.$message.error(res.responseText)
          }
        }
      )
    },
    selectOperation() {
      if (this.$route.query.regionId === '3' && this.form.woCluesType === 12 && this.$route.query.loginOrigin === 'sso') {
        this.showCode = true
        this.getownerCodeList()
        return
      }
      if (this.form.woCluesType === 11 && this.$route.query.loginOrigin === 'sso') {
        this.getwuliuArrByClues()
      }
      this.getshopArrByClues()
    },

    // 单号查商品列表
    getownerCodeList() {
      const { woCluesCode } = this.form
      const param = {
        outSrcOrderId: woCluesCode // SO1619081028
      }
      http.getStoreInfoByOutSoId(param).subscribe((res) => {
        res = res.data
        this.ownerCodeList = res || []
      }, () => {
        this.shopArr = []
      })
    },
    // 单号查商品列表
    getwuliuArrByClues() {
      const { woCluesType, woCluesCode } = this.form
      if (woCluesType === 11) {
        const param = {
          invoiceNum: woCluesCode
        }
        http.listByInvoiceNum(param, { filterResponse: res => res }).subscribe((res) => {
          res = res.data
          if (res.errorCode === 0) {
            this.wuliuArr = res.data || []
          } else {
            this.wuliuArr = []
          }
        }, () => {
          this.wuliuArr = []
          this.form.clewCode = ''
        })
      }
    },
    setFormData(data) {
      console.log('setFormData：', data)
      this.form = Object.assign(this.form, { ...data })
      this.ownerCode = data.ownerCode
      if (this.form.woCluesCode.indexOf(',') !== -1) {
        const [woCluesCode] = this.form.woCluesCode.split(',')
        this.form.woCluesCode = woCluesCode
        // this.form.clewCode = clewCode
      }
      if (this.form.woCluesCode) {
        this.getClewChangeIssueList()
        this.selectOperation()
      }
      if (this.ownerCode) {
        this.getshopArrByClues()
      }
      if (this.form.woReasonId) {
        this.woReasionCode = this.form.woReasionCode
        this.woType = this.form.woType
        this.templateId = this.form.templateId
        delete this.form.woReasionCode
        this.$nextTick(() => {
          this.formItemList = this.form.templateData ? this.form.templateData.formItemList : []
          this.$nextTick(() => {
            this.$refs.createGroupRef.form = this.form.templateData ? this.form.templateData.form : {}
          })
          // this.queryTempleteInfo()
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.view-header {
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  margin-bottom: 12px;
  line-height: 53px;
  font-size: 14px;
  border-bottom: 1px solid #ddd;

  .header-btn {
    cursor: pointer;
  }
}
.create-work-order-view{
  min-height: 600px;
  background: #fff;
  /deep/.clues-item{
    .clues-input{
      width: 200px;
    }
    .clues-select{
      width: 100px;
    }
  }
}
</style>
<style lang="less">
.shop-select{
  .el-select-dropdown__item{
    padding: 5px 10px;
    height: auto;
    line-height: unset;
    background-color: #fff;
  }
  .shop-item{
    display: flex;
    width: 100%;
    overflow: hidden;
    .shop-img{
      flex-shrink: 0;
      width: 60px;
      height: 60px;
      margin-right: 5px;
    }
    .shop-info{
      flex: 1;
      font-weight: 700;
      font-size: 12px;
      overflow: hidden;
      .shop-name{
        display: -webkit-box;
        margin: 0;
        white-space: normal;
        -webkit-line-clamp: 2;
         -webkit-box-orient: vertical;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .shop-type{
        display: block;
        color: #C0C4CC;
      }
      .shop-price{
        display: block;
        color: #F56C6C;
      }
    }
  }
}
</style>
